import LogFileAPI from '../../api/logfile'

const FETCHING_LOGS = 'FETCHING_LOGS',
    FETCHING_LOGS_SUCCESS = 'FETCHING_LOGS_SUCCESS',
    FETCHING_LOGS_ERROR = 'FETCHING_LOGS_ERROR'

export default {
    namespaced: true,
    state: {
        isLoading: false,
        error: null,
        logs: ''
    },
    getters: {
        isLoading(state) {
            return state.isLoading
        },
        hasError(state) {
            return state.error !== null
        },
        error(state) {
            return state.error
        },
        logs(state) {
            return state.logs
        }
    },
    mutations: {
        [FETCHING_LOGS](state) {
            state.isLoading = true
            state.error = null
            state.logs = ''
        },
        [FETCHING_LOGS_SUCCESS](state, logs) {
            state.isLoading = false
            state.error = null
            state.logs = logs
        },
        [FETCHING_LOGS_ERROR](state, error) {
            state.isLoading = false
            state.error = error
            state.logs = ''
        }
    },
    actions: {
        async viewImportLog({ commit }, payload) {
            commit(FETCHING_LOGS)
            try {
                let response = await LogFileAPI.getImportLog(payload)
                commit(FETCHING_LOGS_SUCCESS, response.data.filecontent)
                return response.data.filecontent
            } catch (error) {
                commit(FETCHING_LOGS_ERROR, error)
                return null
            }
        }
    }
}
